import { SamplingEvent } from 'src/shared/types';
import { DateInput, isWithinUtcDayRange } from 'src/shared/utils/dateHelpers';

type SamplingCadenceEvent = Pick<SamplingEvent, 'name' | 'fromDate' | 'toDate'> & {
    year: number;
    event: number;
};

// Find the sampling event whose [fromDate, toDate] window contains the sample's UTC collection time.
export const getEventIndexAndName = (
    sampleCollectedDatetime: DateInput,
    events: SamplingCadenceEvent[]
): { year: number; event: number; name: string } | null => {
    const event = events.find(({ fromDate, toDate }) => isWithinUtcDayRange(sampleCollectedDatetime, fromDate, toDate));
    return event ? { year: event.year, name: event.name, event: event.event } : null;
};
